<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { getEnvVar } from '@/utils/env';

defineProps<{
  title: string;
  subTitle?: string;
}>();

const { t } = useI18n({ useScope: 'global' });
const BASE_URL = getEnvVar('VITE_CDN_BASE_URL');
const loadingIcon = `${BASE_URL}/assets/images/loading.png`;
</script>

<template>
  <div class="retrieve-modal flex flex-column">
    <div class="title mb-2 text-2xl uppercase text-center pb-2 px-2">{{ title }}</div>
    <div class="sub-title text-center pb-2 px-2">{{ subTitle }}</div>
    <div class="loader">
      <img :alt="t('common.generic.loading')" :src="loadingIcon" />
    </div>
  </div>
</template>
<style lang="scss" scoped>
.retrieve-modal {
  width: min(400px, 45vw);
  align-items: center !important;
}
.loader {
  width: 50px;
  height: 50px;
  -webkit-animation: loader linear 1s infinite;
  animation: loader linear 1s infinite;
  img {
    width: 100%;
  }
  @keyframes loader {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
